export default __webpack_public_path__ + "images/20c5bc3169b605e313af29e84addac09.svg";